import { HttpClient } from "@angular/common/http";
import { Injectable, inject } from "@angular/core";
import { CompanyFeatures } from "./rentals-company-features-base.client.interface";
import { environment } from "@environments/environment";

@Injectable({ providedIn: 'root' })
export class RentalsCompanyFeaturesBaseClient {
    private http = inject(HttpClient);

    getCompanyFeatures() {
        const url = `${environment.rentalsApiEndPoint}/base/company-features`;

        return this.http.get<CompanyFeatures>(url);
    }
}